import ViewModel from '../@base/ViewModel';

export default class NetworkViewModel extends ViewModel {
  constructor() {
    super();
  }
}
